import { createSelector } from 'reselect';

import { coworkingFixedWorkplaceWithErrorSelector } from './coworkingFixedWorkplaceWithErrorSelector';

export const coworkingFixedWorkplaceCountSelector = createSelector(
  coworkingFixedWorkplaceWithErrorSelector,
  fixed => fixed.count,
);
